import React from "react"
import Card from "../../../containers/Card/Card"
import WalletTermsField from "./WalletTermsField/WalletTermsField"
import {WalletTermsInterestProps} from "./types"
import {EditMode} from "../../../resources/common"
import classNames from "classnames"
import {toInteger} from "lodash"

export default function Interest({editMode, values, setFieldValue, onBlur}: WalletTermsInterestProps) {
	return (
		<Card
			className="wallet-terms-card-title"
			title={
				<span className="card-title" id="Interest">
					Interest
				</span>
			}
		>
			<div className={classNames("form-row four", editMode === EditMode.VIEW && "view")}>
				<WalletTermsField
					mode={editMode}
					type="select"
					name="OrgInterestShare"
					label={"Org Interest Share"}
					value={values.orgInterestShare / 100 ?? "-"}
					onChange={(value) => setFieldValue("OrgInterestShare", toInteger(value))}
					inputSuffix={values.orgInterestShare !== undefined ? "%" : ""}
					onBlur={onBlur}
				/>
				<WalletTermsField
					mode={editMode}
					type="select"
					name="CustomerInterestShare"
					label={"Customer Interest Share"}
					value={values.customerInterestShare / 100 ?? "-"}
					onChange={(value) => setFieldValue("CustomerInterestShare", toInteger(value))}
					inputSuffix={values.customerInterestShare !== undefined ? "%" : ""}
					onBlur={onBlur}
				/>
				<WalletTermsField
					mode={editMode}
					type="select"
					name="InterestFormula"
					label={"Interest Formula"}
					value={values.interestFormula ?? "-"}
					onChange={(value) => setFieldValue("InterestFormula", value)}
					onBlur={onBlur}
				/>
				<WalletTermsField
					mode={editMode}
					type="select"
					name="InterestRate"
					label={"Interest Rate"}
					value={values.interestRate ?? "-"}
					onChange={(value) => setFieldValue("InterestRate", value)}
					onBlur={onBlur}
				/>
			</div>
		</Card>
	)
}
